export type Resolve<T> = (value: T) => void;
export type Reject<E = any> = (reason?: E) => void; // tslint:disable-line:no-any

/**
 * Creates a "deferred" object that can be resolved later by the same code that created the promise.
 * "Deferred" is syntactic sugar for saving a promise's `resolve` function onto a closed scope
 * (in order to manually invoke it later), but our compiler does not treat this pattern nicely.
 *
 * This replicates the basic Deferred functionality of the Q library, but uses an ES6 promise,
 * thus avoiding us having to take a dependency on Q.
 */
// tslint:disable-next-line:no-any
export class SimpleDeferred<T, E = any> {

  public readonly promise: Promise<T>;

  // These members actually gets assigned in the promise constructor, but we have
  // to give it some initial value to appease the compiler
  private _resolve: Resolve<T> = () => {}; // tslint:disable-line
  private _reject: Reject<E> = () => {}; // tslint:disable-line

  public constructor() {
    this.promise = new Promise<T>((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });
  }

  public get resolve(): Resolve<T> {
    return this._resolve;
  }

  public get reject(): Reject<E> {
    return this._reject;
  }
}
